import { useTranslation } from "react-i18next";

import { MeterRow } from "./MeterRow";
import { BALANCE_FILL } from "../constants";
import type { balanceTracks } from "../utils";

import { cn } from "@/lib/utils/cn";

type BalanceTracksProps = {
  tracks: ReturnType<typeof balanceTracks>;
  capClass: string;
};

export function BalanceTracks({ tracks, capClass }: BalanceTracksProps) {
  const { t } = useTranslation();
  return (
    <MeterRow
      aside={tracks.capacity > 0 ? t("captainBilling.tiles.usedPercent", { percent: Math.round(tracks.usedPercent) }) : undefined}
    >
      <div
        role="img"
        aria-label={t("captainBilling.tiles.usedLabel", {
          cap: Math.round(tracks.cap?.usedPercent ?? 0),
          topUp: Math.round(tracks.topUp?.usedPercent ?? 0),
        })}
        className="flex h-2 gap-0.5"
      >
        {tracks.cap && <UsageTrack share={tracks.cap.share} usedPercent={tracks.cap.usedPercent} fill={capClass} />}
        {tracks.topUp && <UsageTrack share={tracks.topUp.share} usedPercent={tracks.topUp.usedPercent} fill={BALANCE_FILL.topUp} />}
        {!tracks.cap && !tracks.topUp && <span className="flex-1 rounded-full bg-muted" />}
      </div>
    </MeterRow>
  );
}

function UsageTrack({ share, usedPercent, fill }: { share: number; usedPercent: number; fill: string }) {
  return (
    <span className="relative overflow-hidden rounded-full bg-muted" style={{ flexGrow: share, flexBasis: 0 }}>
      <span
        className={cn("absolute inset-y-0 left-0 rounded-full transition-[width] duration-700 ease-out motion-reduce:transition-none", fill)}
        style={{ width: `${usedPercent}%` }}
      />
    </span>
  );
}
